import React from "react";
import { Box, Button, Typography, styled } from "@mui/material";
import { BackArrowIcon } from "../../icons/BackArrowIcon";
import type { MSHatData } from "../../../types";

interface AHSHeaderProps {
  onClose: () => void;
  hat: MSHatData;
}

const HeaderContainer = styled(Box, {
  label: "AHSHeaderContainer",
})(() => ({
  display: "flex",
  flexDirection: "column",
}));

const HeaderContent = styled(Box, {
  label: "AHSHeaderContent",
})(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(2),
  padding: theme.spacing(3),
}));

const ExitButton = styled(Button, {
  label: "AHSExitButton",
})(({ theme }) => ({
  color: "#ffffff",
  border: `1px solid rgba(145, 158, 171, 0.32)`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  minWidth: 64,
  height: 36,
  fontSize: "14px",
  fontWeight: 700,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },
}));

const HeaderInfo = styled(Box, {
  label: "AHSHeaderInfo",
})(() => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: 8,
}));

const HatInfoSection = styled(Box, {
  label: "AHSHatInfo",
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginLeft: "auto",
}));

const HatImage = styled("img", {
  label: "AHSHatImage",
})(() => ({
  width: 32,
  height: 32,
  borderRadius: "50%",
  objectFit: "cover",
  boxShadow:
    "0px 0px 2px 0px rgba(0, 0, 0, 0.2), 0px 12px 24px 0px rgba(0, 0, 0, 0.12)",
}));

const RoadSignIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2L4 7V17L12 22L20 17V7L12 2Z"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V16"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 12H16"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const AHSHeader = ({ onClose, hat }: AHSHeaderProps) => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <ExitButton
          variant="outlined"
          startIcon={<BackArrowIcon width={20} height={20} color="#ffffff" />}
          onClick={onClose}
        >
          Exit
        </ExitButton>

        <HeaderInfo>
          <RoadSignIcon />
          <Typography
            variant="h4"
            sx={{
              color: "#ffffff",
              fontFamily: "Proxima Nova",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "36px",
              flex: 1,
            }}
          >
            After High School
          </Typography>

          <HatInfoSection>
            {hat.displayImage?.url && (
              <HatImage
                src={
                  hat.displayImage.sizes?.hatCard?.url || hat.displayImage.url
                }
                alt={hat.displayName}
              />
            )}
            <Typography
              sx={{
                fontFamily: "Proxima Nova",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "22px",
                color: "#ffffff",
              }}
            >
              {hat.displayName}
            </Typography>
          </HatInfoSection>
        </HeaderInfo>
      </HeaderContent>
    </HeaderContainer>
  );
};
